import React from 'react';
import { ArrowRightIcon, CheckIcon, LockIcon, QuoteIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CHECKOUT_URL, IMAGES, PRICES, modules, testimonials } from '../data/funnel';
import { formatUsd } from '../utils/currency';
import { trackAddToCart } from '../utils/metaPixel';
import { redirectTop } from '../utils/navigation';
const painPoints = ['Ronca, jadea y se agota en caminatas de 10 minutos.', 'Se rasca los pliegues hasta dejarse la piel roja.', 'Duda antes de subir al sofá o arrastra las patas al levantarse.', 'Cada visita al veterinario termina en otra factura de tres cifras.'];
export function SalesPage() {
  function handleAddToCart(event: React.MouseEvent<HTMLAnchorElement>) {
    // Deja que el navegador maneje cmd/ctrl/middle click en una pestaña nueva.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    trackAddToCart({
      content_name: 'Protocolo de Biohacking para Bulldogs Franceses',
      content_ids: ['44410140852289'],
      value: PRICES.blueprint
    });
    // Pequeña espera para que el evento salga antes de abandonar la página,
    // y luego una redirección normal (nunca dentro de un iframe).
    window.setTimeout(() => redirectTop(CHECKOUT_URL), 200);
  }
  return <main className="w-full bg-cream pb-24" data-id="element-102" data-mp="2vvvd91fylioz">
      <div className="bg-navy-deep text-paper" data-id="element-103" data-mp="2vszfbd442u0j">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-x-2 px-5 py-2.5 text-center text-xs font-medium text-gold-pale sm:text-sm" data-id="element-104" data-mp="3thjatpo5i723">
          <ZapIcon className="h-3.5 w-3.5 text-gold" data-id="element-105" data-mp="3jkepfs24qfmc" />
          Oferta de lanzamiento: <strong className="font-bold text-paper" data-id="element-106" data-mp="3jmhjqoabeuwv">85% de descuento</strong>{' '}
          para dueños en USA · solo esta semana
        </div>
      </div>

      <section className="mx-auto max-w-6xl px-5 pt-12 sm:pt-16" data-id="element-107" data-mp="286at4f82kfe4">
        <div className="grid items-center gap-10 lg:grid-cols-[1.15fr_1fr] lg:gap-14" data-id="element-108" data-mp="243wb1xc85jnw">
          <div data-id="element-109" data-mp="25ktnqedhft9m">
            <h1 className="font-display text-[2rem] font-bold leading-[1.12] tracking-tight text-navy-deep sm:text-[2.9rem]" data-id="element-110" data-mp="25l35xfsacw4r">
              El plan de 30 días que protege la columna, la respiración y la piel de tu Bulldog
              Francés
            </h1>
            <p className="mt-5 max-w-xl text-lg leading-relaxed text-navy/75" data-id="element-111" data-mp="1voqaodh3ea7w">
              El Protocolo de Biohacking traduce lo que hacen los dueños de Frenchies de 12 y 14
              años en una rutina diaria de 7 minutos, con el{' '}
              <strong className="font-semibold text-navy-deep" data-id="element-112" data-mp="1rlk93j4xd77r">Protocolo Spine-Shield</strong> como
              núcleo.
            </p>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-113" data-mp="1cxpd9tvmemqg">
              {['Rutina diaria de 7 minutos', 'Transición de dieta semana por semana', 'Protocolo de calor para verano', 'Acceso inmediato en PDF + móvil'].map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-navy-deep/85" data-id="element-114" data-mp="17z5q5q5aj4wi">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" data-id="element-115" data-mp="p90v6vapgxf0" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-8 flex flex-wrap items-center gap-x-5 gap-y-3" data-id="element-116" data-mp="y9pbjwnkn9v2">
              <a href={CHECKOUT_URL} onClick={handleAddToCart} className="group inline-flex items-center justify-center gap-2 rounded-lg bg-navy-deep px-7 py-4 text-base font-bold text-paper shadow-card transition-colors duration-150 ease-out hover:bg-navy sm:text-lg" data-id="element-117" data-mp="tam4k6o16tkg">
                Quiero el protocolo por ${formatUsd(PRICES.blueprint)}
                <ArrowRightIcon className="h-5 w-5 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-118" data-mp="1cxtm2dch0f2r" />
              </a>
              <p className="text-sm text-navy/60" data-id="element-119" data-mp="1qymi52if7i7z">
                <span className="line-through" data-id="element-120" data-mp="1lz9yeqmuir9m">${formatUsd(PRICES.blueprintValue)}</span> hoy{' '}
                <strong className="font-bold text-navy-deep" data-id="element-121" data-mp="261e5w12mwzrd">
                  ${formatUsd(PRICES.blueprint)}
                </strong>
              </p>
            </div>
          </div>

          <div className="justify-self-center" data-id="element-122" data-mp="2etg5jx4vqc0l">
            <img src={IMAGES.cover} alt="El Protocolo de Biohacking para Bulldogs Franceses, plan de 30 días, en ebook y tablet" className="w-full max-w-md rounded-xl shadow-lift" data-id="element-123" data-mp="2eur85tml9dq4" />
          </div>
        </div>
      </section>

      <section className="mx-auto mt-20 max-w-6xl px-5" data-id="element-124" data-mp="1r33p1xvkj6ye">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.1fr] lg:items-start lg:gap-16" data-id="element-125" data-mp="1r5ou0vr5y30d">
          <div data-id="element-126" data-mp="1w51fpd6at41d">
            <h2 className="font-display text-2xl font-bold leading-snug text-navy-deep sm:text-3xl" data-id="element-127" data-mp="1w5b3cu3vez3w">
              Si reconoces dos o más de estas señales, el reloj ya está corriendo
            </h2>
            <ul className="mt-6 space-y-3" data-id="element-128" data-mp="3ch83wufobj9r">
              {painPoints.map(p => <li key={p} className="flex items-start gap-3 border-l-2 border-alert/60 pl-4 text-base leading-relaxed text-navy/80" data-id="element-129" data-mp="3cjb2w3yt0mqm">
                  {p}
                </li>)}
            </ul>
          </div>
          <figure className="overflow-hidden rounded-xl" data-id="element-130" data-mp="r2h0u1p2o7pz">
            <img src={IMAGES.food} alt="Ingredientes frescos de comida natural para perro sobre una mesada de piedra clara" className="aspect-[3/2] w-full object-cover" data-id="element-131" data-mp="m5i89nl248tw" />
            <figcaption className="mt-2 text-sm leading-relaxed text-navy/60" data-id="element-132" data-mp="d3hc6u1k7stt">
              El protocolo no exige cocinar todos los días. Empieza retirando tres ingredientes de
              la croqueta que tu perro ya come.
            </figcaption>
          </figure>
        </div>
      </section>

      <section className="mx-auto mt-20 max-w-6xl px-5" data-id="element-133" data-mp="22hxa4yydpxej">
        <h2 className="font-display text-2xl font-bold text-navy-deep sm:text-3xl" data-id="element-134" data-mp="1xkdk71sbjw6r">
          Qué hay dentro del protocolo
        </h2>
        <p className="mt-2 max-w-2xl text-base text-navy/65" data-id="element-135" data-mp="3rzaws7k7hlm3">
          Cinco bloques que se ejecutan en orden. Cada uno toma menos de una tarde en configurar.
        </p>

        <ol className="mt-8 space-y-px overflow-hidden rounded-xl bg-navy-deep/10" data-id="element-136" data-mp="3i2offsr39cot">
          {modules.map(m => <li key={m.number} className="grid gap-2 bg-paper p-6 sm:grid-cols-[auto_1fr] sm:gap-6 sm:p-7" data-id="element-137" data-mp="3n2arvzz3eowk">
              <span className="font-display text-lg font-bold text-gold sm:pt-0.5" data-id="element-138" data-mp="ejmrpvtknwn5">{m.number}</span>
              <div data-id="element-139" data-mp="ji6fm1rq7ii5">
                <h3 className="font-display text-lg font-bold text-navy-deep" data-id="element-140" data-mp="5l1ac3zu6nny">{m.title}</h3>
                <p className="mt-1.5 max-w-2xl text-[0.95rem] leading-relaxed text-navy/70" data-id="element-141" data-mp="9mcw1yflaoqv">
                  {m.description}
                </p>
              </div>
            </li>)}
        </ol>
      </section>

      <section className="mx-auto mt-20 max-w-6xl px-5" data-id="element-142" data-mp="2ucu3reii9u65">
        <h2 className="font-display text-2xl font-bold text-navy-deep sm:text-3xl" data-id="element-143" data-mp="2ua8y0ef36u34">
          Dueños que ya dejaron de reaccionar
        </h2>
        <div className="mt-8 grid gap-6 lg:grid-cols-[1.25fr_1fr]" data-id="element-144" data-mp="2hurczhrldkbn">
          <figure className="flex flex-col overflow-hidden rounded-xl bg-navy-deep text-paper" data-id="element-145" data-mp="2wr8nk6ryiux5">
            <img src={testimonials[0].photo} alt={`${testimonials[0].name} abrazando a su Bulldog Francés en casa`} className="aspect-[4/3] w-full object-cover" data-id="element-146" data-mp="2rs5u7jlcad50" />
            <blockquote className="flex flex-1 flex-col p-6 sm:p-7" data-id="element-147" data-mp="1z409gwuaco56">
              <QuoteIcon className="h-5 w-5 text-gold" data-id="element-148" data-mp="1z1nhdqutcxee" />
              <p className="mt-3 font-display text-lg leading-relaxed sm:text-xl" data-id="element-149" data-mp="2dtfudw74xzcy">
                {testimonials[0].quote}
              </p>
              <figcaption className="mt-auto pt-5 text-sm text-gold-pale" data-id="element-150" data-mp="28zti454vvxho">
                <span className="font-semibold text-paper" data-id="element-151" data-mp="1laimt36ayvax">{testimonials[0].name}</span> ·{' '}
                {testimonials[0].location} · {testimonials[0].dogAge}
              </figcaption>
            </blockquote>
          </figure>

          <div className="grid gap-6" data-id="element-152" data-mp="zsqy7t6r2b26">
            {testimonials.slice(1).map(t => <figure key={t.name} className="flex h-full flex-col rounded-xl border border-navy-deep/10 bg-paper p-6" data-id="element-153" data-mp="zulir6e4015q">
                <p className="text-[0.95rem] leading-relaxed text-navy/80" data-id="element-154" data-mp="18v07ygu720ei">“{t.quote}”</p>
                <figcaption className="mt-auto pt-4 text-sm text-navy/55" data-id="element-155" data-mp="1drqo14600vzx">
                  <span className="font-semibold text-navy-deep" data-id="element-156" data-mp="1iquuvo5gahn3">{t.name}</span> · {t.location} ·{' '}
                  {t.dogAge}
                </figcaption>
              </figure>)}
          </div>
        </div>
      </section>

      <section className="mx-auto mt-20 max-w-3xl px-5" data-id="element-157" data-mp="1sgms6q4xpov9">
        <div className="rounded-2xl border border-navy-deep/10 bg-paper p-7 shadow-card sm:p-10" data-id="element-158" data-mp="1wjsuxnsu8xwz">
          <h2 className="font-display text-2xl font-bold text-navy-deep sm:text-3xl" data-id="element-159" data-mp="21hckhjuzkx48">
            Tu acceso hoy
          </h2>
          <dl className="mt-6 divide-y divide-navy-deep/10 border-y border-navy-deep/10" data-id="element-160" data-mp="3m0y9dhthm4zo">
            <div className="flex items-baseline justify-between gap-4 py-3" data-id="element-161" data-mp="3h0ah6stivi3v">
              <dt className="text-[0.95rem] text-navy/80" data-id="element-162" data-mp="3cyyqsl2tqsum">
                Protocolo de Biohacking — Plan de 30 días
              </dt>
              <dd className="shrink-0 text-sm text-navy/55" data-id="element-163" data-mp="381yie3ii5e0c">
                ${formatUsd(PRICES.blueprintValue)}
              </dd>
            </div>
          </dl>

          <div className="mt-6 flex flex-wrap items-end justify-between gap-4" data-id="element-164" data-mp="4jeybo9z9egm">
            <div data-id="element-165" data-mp="3vy2urffidwff">
              <p className="text-sm font-semibold uppercase tracking-[0.14em] text-navy/50" data-id="element-166" data-mp="3vxjd7ztrta1x">
                Hoy pagas
              </p>
              <p className="font-display text-5xl font-bold leading-none text-navy-deep" data-id="element-167" data-mp="3qyzo5qjvri5c">
                ${formatUsd(PRICES.blueprint)}
              </p>
            </div>
            <p className="text-sm text-navy/60" data-id="element-168" data-mp="nhhsehhdu1la">Pago único · sin suscripción</p>
          </div>

          <a href={CHECKOUT_URL} onClick={handleAddToCart} className="group mt-7 flex w-full items-center justify-center gap-2 rounded-lg bg-gold px-6 py-4 text-lg font-bold text-navy-deep transition-colors duration-150 ease-out hover:bg-gold-light" data-id="element-169" data-mp="31fb0bfd0vkws">
            Empezar el protocolo hoy
            <ArrowRightIcon className="h-5 w-5 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-170" data-mp="36c1iq9causld" />
          </a>

          <div className="mt-5 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-navy/55" data-id="element-171" data-mp="3feaoklwmhxsf">
            <span className="flex items-center gap-1.5" data-id="element-172" data-mp="3u2notv2qu2sq">
              <ShieldCheckIcon className="h-4 w-4 text-navy/40" data-id="element-173" data-mp="3u245c9xg36cl" />
              Garantía de 30 días sin preguntas
            </span>
            <span className="flex items-center gap-1.5" data-id="element-174" data-mp="6y7igkl5sh67">
              <LockIcon className="h-4 w-4 text-navy/40" data-id="element-175" data-mp="6yqytwv5uxi4" />
              Pago cifrado
            </span>
          </div>
        </div>
      </section>

      <footer className="mx-auto mt-16 max-w-3xl px-5 text-xs leading-relaxed text-navy/45" data-id="element-176" data-mp="ll66s6opyvgp">
        Material educativo. No sustituye la consulta veterinaria. © {new Date().getFullYear()} The
        Frenchie Longevity Report.
      </footer>
    </main>;
}